module.exports = __webpack_public_path__ + "media/images/avatar/11-6009b3fc879972037da54dd34ae3e828.jpg";